<template>
  <div class="train">
    <div class="train-title">
      <img src="../../assets/imgs/train01.png" />
      <span>实训题</span>
    </div>
    <div class="train-content">
      <el-form :model="trainObj" :rules="trainRules" ref="trainObj" label-width="100px" class="demo-ruleForm">
        <el-form-item label="满分" prop="full_marks" class="train-list">
          <el-input v-model.trim="trainObj.full_marks" min="0" max="150" placeholder="请输入满分值" @keyup.native="UpNumber" @keydown.native="UpNumber"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title" class="train-list">
          <el-input v-model.trim="trainObj.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="desc" class="train-list">
          <!--<el-input type="textrea" v-model.trim="trainObj.desc" :rows="5"></el-input>-->
          <TinymceEditor :ref_id="`descref`" :content="trainObj.desc" :editor_belong="`desc`" :editor_class="`train-describe`" :upload_url="singleUpload" v-model="trainObj.desc"
            @on-change="descChange">
          </TinymceEditor>
        </el-form-item>
        <el-form-item label="教学文件" prop="video_url" class="train-list video">
          <el-upload class="video-uploader" name="video" action="" :http-request="fnUploadRequest" :show-file-list="true" :file-list="teachFiles" :on-success="handleVideoSuccess"
            :before-upload="beforeVideoUpload" :data="{filename: 'video'}" :before-remove="(file, fileList)=>beforeTeachFileRemove('teach',file, fileList)"
            :on-remove="(file, fileList)=>handleFileRemove('teach',file, fileList)" accept=".pdf,.doc,.ppt,.docx,.pptx,.mp4" :limit="1" :on-exceed="tips">
            <span class="icon">+</span>
            <div class="el-upload__text">
              <span>添加文件</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item class="train-list train-upload">
          <el-upload class="upload-material" action="" :http-request="fnUploadRequest" name="files" :file-list="materials"
            :before-remove="(file, fileList)=>beforeTeachFileRemove('materials',file, fileList)" list-type="text" :on-success="handleMaterialsSuccess" :data="{filename: 'files'}"
            :on-remove="(file, fileList)=>handleFileRemove('materials',file, fileList)" :before-upload="(file)=>beforeFileUpload('materials',file)"
            accept=".png,.jpge,.jpg,.gif,.mp4,.rar,.zip,.pdf,.doc,.ppt,.docx,.pptx" :limit="5" :on-exceed="cktips">
            <div style="display: flex;">
              <el-button size="small" type="primary">
                <i class="el-icon-upload2"></i> 参考资料
              </el-button>
              <div slot="tip" class="el-upload__tip">（上传所需的素材\资料提供下载）</div>
            </div>
          </el-upload>
        </el-form-item>
        <span style="display:block;width:100%;height:1px;border-bottom: 1px solid #DCE1E6;"></span>
        <el-form-item label="实训工具" class="train-list train-item train-tool">
          <div class="section-content">
            <ul class="ul-list">
              <li class="ul-item" v-for="(item,index) in trainObj.tools" :key="'traintools'+index">
                <span class="num">{{index}}</span>
                <input type="text" placeholder="点击输入或者点击右侧按钮添加实训工具" v-model="item.name">
                <el-row class="block-col-2">
                  <el-col title="点击添加实训工具">
                    <el-dropdown trigger="click">
                      <span class="el-dropdown-link">
                        <i class="el-icon-plus"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown" class="train-tool-item">
                        <el-dropdown-item>
                          <div :class="n%2 === 0 ? 'train-tool-2': 'train-tool-1'" v-for="n in 5" :key="n+'train-tool'">
                            <div class="tool-item" v-for="(v,i) in toolsData[n]" :key="i+'tooldata'" @click="chooseTool(index, n, i)">
                              <img :src="v.img" />
                              <span v-text="v.name"></span>
                            </div>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-col>
                </el-row>
                <a class="delete-btn bg" title="删除" @click="deleteTool(index)">
                  <i class="el-icon-close"></i>
                </a>
              </li>
              <el-button size="small" type="primary" class="add-tool" @click.native="addTool">
                <span style="margin: 0 5px;font-size: 14px;">+</span>添加工具
              </el-button>
            </ul>
          </div>
        </el-form-item>
        <span style="display:block;width:100%;height:1px;border-bottom: 1px solid #DCE1E6;"></span>
        <el-form-item label="实训步骤" class="train-list train-item train-step">
          <div class="section-content">
            <div class="ul-list">
              <li class="ul-item" v-for="(item,index) in trainObj.main" :key="'trainmain'+index">
                <div class="wgt-step-item">
                  <span class="num1">{{index+1}}</span>
                  <TinymceEditor :ref_id="`mainref${index}`" :content="item.content" :index="index" :editor_belong="`main`" :upload_url="singleUpload" :key="index"
                    v-model="item.content">
                  </TinymceEditor>
                  <el-upload class="upload-file" action="" :http-request="fnUploadRequest" name="files" :before-upload="(file)=>beforeFileUpload('step',file, index)"
                    :before-remove="(file, fileList)=>beforeFileRemove('step',file, fileList, index)" list-type="text" :file-list="mainFiles[index]" :limit="10"
                    :on-success="(res, file)=>handleMainImgSuccess(index, res, file)" :on-remove="(file, fileList)=>handleFileRemove('step',file, fileList, index)"
                    :on-exceed="(files, fileList)=>handleExceed('step',files, fileList, index)" multiple :data="{filename: 'files'}" accept=".png,.jpge,.jpg,.gif">
                    <div style="display: flex;height: 30px;margin-top: 22px;">
                      <el-button size="small" type="primary">
                        <span style="margin: 0 5px;font-size: 14px;">+</span>添加图片
                      </el-button>
                    </div>
                  </el-upload>
                  <div class="li-btn">
                    <a class="move-btn bg" title="上移" v-if="index!==0">
                      <i class="el-icon-sort-up handle" @click="upSteps(index)"></i>
                    </a>
                    <a class="move-btn bg" title="下移" v-if="index!==trainObj.main.length-1">
                      <i class="el-icon-sort-down handle" @click="downSteps(index)"></i>
                    </a>
                    <a class="delete-btn bg" title="删除" @click='rmStep(index)'>
                      <i class="el-icon-close"></i>
                    </a>
                    <a class="add-btn bg" title="添加" @click="addStep(index)">
                      <i class="el-icon-plus"></i>
                    </a>
                  </div>
                </div>
              </li>
            </div>
            <el-button size="small" type="primary" class="add-step" @click.native="addStep">
              <span style="margin: 0 5px;font-size: 14px;">+</span>添加步骤
            </el-button>
          </div>
        </el-form-item>
        <el-collapse accordion v-model="activity_attr">
          <el-collapse-item class="set-attr" :name="1">
            <template slot="title">
              <span style="padding-left: 62px;">活动属性</span>
            </template>
            <div style="padding-left: 30px;">
              <el-form-item label="经验值" prop="exp">
                <el-input v-model.trim="trainObj.exp" size="small" min="0" placeholder="5"></el-input>
              </el-form-item>
              <el-form-item label="积分" prop="bp">
                <el-input v-model.trim="trainObj.bp" size="small" min="0" placeholder="5"></el-input>
              </el-form-item>
              <el-form-item label="标签" class="not-must" prop="tagValue">
                <el-tag :key="tag" v-for="tag in trainObj.tags" closable :disable-transitions="false" @close="handleClose(tag, 'subject')">
                  {{tag}}
                </el-tag>
                <el-input class="input-new-tag" v-if="tagVisible" v-model.trim="tagValue" :maxlength="10" ref="saveTagInput" size="small"
                  @keyup.enter.native="handleInputConfirm('subject')" @blur="handleInputConfirm('subject')">
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showTagInput('subject')">+ 标签</el-button>
              </el-form-item>
              <el-form-item label="难度">
                <el-radio-group label="难度" v-model="trainObj.difficulty">
                  <el-radio :label="1">简单</el-radio>
                  <el-radio :label="2">一般</el-radio>
                  <el-radio :label="3">困难</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-form-item class="general-preview" style="text-align: center;border-top: none;margin:5px 0;">
          <el-button type="primary" size="medium" @click="saveTrain('trainObj')">保存</el-button>
          <el-button type="info" size="medium" plain>预览</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import oss from '@/utils/aliOss'
import { saveTargetProjectTaskAddActivity, selectTargetProjectTaskActivity, savePaperTopicContent } from '@/api/contest'
import draggable from 'vuedraggable'
import TinymceEditor from "@/components/test/TinymceEditor";
export default {
  name: "handle",
  display: "Handle",
  instruction: "Drag using the handle icon",
  order: 5,
  components: {
    draggable,
    TinymceEditor,
  },
  computed: {

  },
  beforeDestroy() {
    this.$root.$off('maineditorchange')
  },
  props: ['paperId', 'contentId', 'editorData'],
  watch: {
    //根据每个活动的paperId变化来获取数据，paperId不变化数据不更新
    paperId: function () {
      this.fetchData()
    },
    contentId: function () {
      this.fetchData()
    }
  },

  created() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  mounted() {
    this.fetchData()
    this.$root.$on('maineditorchange', (obj) => {
      this.getStepContent(obj)
    })
  },
  data() {
    const validators = function (rule, value, callback) {
      var errors = [];
      if (!/^[0-9]+$/.test(value)) {
        callback('请输入0-100以内的正整数!');
      }
      if (value > 100 || value < 0) {
        callback('请输入0-100以内的正整数!');
      }
      callback(errors);
    }
    const descValid = function (rule, value, callback) {
      var errors = [];
      var span = document.createElement('span')
      span.innerHTML = value
      value = span.innerText.replace(/\s+/, '')
      if (!value.length) {
        callback('请输入简介！');
      }
      callback(errors);
    }
    return {
      singleUpload: '/test/ossUpload',
      editor: '',
      toolsData: {
        1: [{
          name: 'C2C实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101542_n73g.png',
          url: 'http://taobao.yikesoft.cn'
        }, {
          name: 'B2B2C实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101602_oh2j.png',
          url: 'http://jd.yikesoft.cn'
        }, {
          name: 'B2C实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101506_n6ic.png',
          url: 'http://kaola.yikesoft.cn'
        }, {
          name: '跨境C2C实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101642_agr6.png',
          url: 'http://kj.yikesoft.cn'
        }, {
          name: '跨境B2B实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101628_yfvi.png',
          url: 'http://alibaba.yikesoft.cn'
        }, {
          name: '跨境B2B2C实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101613_y67v.png',
          url: 'http://amazon.yikesoft.cn'
        },
        {
          name: 'B2C实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101531_ghqe.png',
          url: 'http://handu.yikesoft.cn'
        }, {
          name: 'B2B实战',
          img: 'http://classbot.oss-cn-beijing.aliyuncs.com/official/thetest/image/20191118101428_959v.png',
          url: 'http://1688.yikesoft.cn'
        }]
      },
      teachFiles: [], // 教学文件的只读文件
      materials: [], // 素材的只读文件
      mainFiles: [],
      toolFiles: [],//实训工具提交时临时存放地址
      stepFiles: [],//实训步骤提交时临时存放地址
      trainObj: {
        id: '',
        status: 1, //1-完整 2-草稿
        type: 'Train',
        title: '',
        desc: '',
        video_url: [], //教程视频\文件
        main: [], //实训步骤
        materials: [],
        tools: [], //已选的实训工具
        copies: 2, // 稿件
        full_marks: 100,
        bp: 5,
        exp: 5,
        difficulty: 2,
        tags: []
      },
      activity_attr: 0,
      trainRules: {
        full_marks: [
          { required: true, message: '请输入满分值！', trigger: 'blur' },
          {
            validator(rule, value, callback, source, options) {
              var errors = [];
              if (!/^[a-z0-9]+$/.test(value)) {
                callback('请输入0-150以内的正整数！');
              }
              if (value > 150 || value < 0 || value === '') {
                callback('请输入0-150以内的正整数！');
              }
              callback(errors);
            }
          }
        ],
        title: [
          { required: true, message: '请输入标题！', trigger: 'blur' },
          { min: 1, max: 30, message: '请输入1-30位字符！', trigger: 'change' }
        ],
        desc: [
          { required: true, validator: descValid, trigger: 'blur' },
          { validator: descValid, trigger: 'change' }
        ],
        exp: [
          { required: true, validator: validators, trigger: 'blur' },
          { validator: validators, trigger: 'change' }
        ],
        bp: [
          { required: true, validator: validators, trigger: 'blur' },
          { validator: validators, trigger: 'change' }
        ],

      },
      tagVisible: false,
      tagValue: '', //标签值
      material_id: '',
    }
  },
  methods: {
    descChange(html) {
      this.trainObj.desc = html
    },
    //只可输入数字
    UpNumber(e) {
      e.target.value = e.target.value.replace(/[^\d\.]/g, "");//限制输入正整数
    },
    //
    fetchData: function () {
      this.resetData()
      if (this.editorData) {
        this.setObj(this.editorData)
      }
    },
    //填充数据,赋值this.trainObj
    setObj: function (data) {
      this.trainObj.id = data.id
      this.trainObj.desc = data.training_introduce
      this.trainObj.title = data.topic_title
      this.trainObj.full_marks = data.score
      this.trainObj.video_url = data.training_url
      this.trainObj.materials = data.materials
      this.trainObj.tools = data.training_tool
      this.trainObj.main = data.training_steps
      this.trainObj.bp = data.integral
      this.trainObj.exp = data.experience
      this.trainObj.tags = data.label
      this.trainObj.difficulty = Number(data.difficulty)
      this.teachFiles = data.training_url
      this.activity_attr = data.activity_attribute
      this.materials = [...data.materials]
      this.restoreMainFiles()
    },
    restoreMainFiles() {
      for (let index = 0; index < this.trainObj.main.length; index++) {
        this.mainFiles[index] = []
        if (this.trainObj.main[index].hasOwnProperty('file')) {
          for (let j = 0; j < this.trainObj.main[index].file.length; j++) {
            this.mainFiles[index].push({
              url: this.trainObj.main[index].file[j].url,
              name: this.trainObj.main[index].file[j].name,
            })
          }
        }
      }
    },
    // 选取实训工具
    chooseTool(toolIndex, n, toolDataIndex) {
      const toolObj = JSON.parse(JSON.stringify(this.toolsData[n][toolDataIndex]))
      this.$set(this.trainObj.tools, toolIndex, toolObj)
    },
    changeCopies() {
      if (this.trainObj.copies <= 2 || !this.trainObj.copies || isNaN(this.trainObj.copies)) {
        this.trainObj.copies = 2
      }
    },
    // 标签删除
    handleClose(tag, type = '') {
      if (type === 'activity') {
        this.activitySetting.tags.splice(this.activitySetting.tags.indexOf(tag), 1);
      }
      if (type === 'subject') {
        this.trainObj.tags.splice(this.trainObj.tags.indexOf(tag), 1);
      }
    },
    // 增加标签
    showTagInput(type = '') {
      if ((type === 'activity' && this.activitySetting.tags.length >= 5) ||
        (type === 'subject' && this.trainObj.tags.length >= 5)) {
        this.$message('最多只能添加五个标签');
        return;
      }
      this.tagVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 标签输入确认
    handleInputConfirm(type = '') {
      if (this.tagValue) {
        if (type === 'activity' && this.activitySetting.tags.indexOf(this.tagValue) === -1) {
          this.activitySetting.tags.push(this.tagValue);
        }
        if (type === 'subject' && this.trainObj.tags.indexOf(this.tagValue) === -1) {
          this.trainObj.tags.push(this.tagValue);
        }
      }
      this.tagVisible = false;
      this.tagValue = '';
    },
    saveTrain(formName) {

      this.trainObj.desc = this.trainObj.desc.replace(/\"/g, "'");
      // main里的也要处理
      if (this.trainObj.main.length > 0) {
        for (let j = 0; j < this.trainObj.main.length; j++) {
          if (this.trainObj.main[j].content) {
            this.trainObj.main[j].content = this.trainObj.main[j].content.replace(/\"/g, "'");
          }
        }
      }
      this.filterTrainingData()
      this.changeData()

      let subject = {
        ...this.trainObj,
      }

      //教学文件转换字符串上传
      let videoTemp = []
      if (subject.video_url.length > 0) {
        subject.video_url.forEach((item) => {
          let arr = ''
          for (let i in item) {
            if (i == 'name') {
              arr += item[i] + '!!'
            } else if (i == 'url') {
              arr += item[i]
            }
          }
          videoTemp.push(arr)
        })
      }

      //素材参考资料转换字符串上传
      let temp = [];
      if (subject.materials.length > 0) {
        subject.materials.forEach((item) => {
          let arr = ''
          for (let i in item) {
            if (i == 'name') {
              arr += item[i] + '!!'
            } else if (i == 'url') {
              arr += item[i]
            }
          }
          temp.push(arr)
        })
      }

      var params = {
        paper_id: this.paperId,
        paper_content_id: this.contentId ? this.contentId : 0,
        paper_type: 9,
        material_id: this.material_id ? this.material_id : 0,
        score: subject.full_marks,
        training_title: subject.title,
        training_introduce: subject.desc,
        training_url: videoTemp,
        materials: temp,
        training_tool: this.toolFiles,
        training_steps: this.stepFiles,
        activity_attribute: this.activity_attr,
        experience: subject.exp,
        integral: subject.bp,
        label: subject.tags,
        difficulty: subject.difficulty
      }
      sessionStorage.setItem('Train', subject.full_marks)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          savePaperTopicContent(params).then(response => {
            this.$message.success('保存成功')
            this.$root.$emit('returntrain', response.data);
          })
        }
      })

    },
    resetData() {
      this.trainObj = {
        id: '',
        status: 1, //1-完整 2-草稿
        type: 'Train',
        title: '',
        desc: '',
        video_url: [], //教程视频\文件
        main: [], //实训步骤
        materials: [],
        tools: [], //已选的实训工具
        copies: 2, // 稿件
        full_marks: sessionStorage.getItem('Train') ? sessionStorage.getItem('Train') : 100,
        bp: 5,
        exp: 5,
        difficulty: 2,
        tags: []
      }
      this.toolFiles = []
      this.stepFiles = []
      this.activity_attr = 0
      this.materials = []
      this.teachFiles = []
      this.mainFiles = []

    },
    //todo 实训题预览
    previewTraining(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

        } else {
          return false;
        }
      });
    },
    filterTrainingData() {
      for (let index = 0; index < this.trainObj.tools.length; index++) {
        const tool = this.trainObj.tools[index];
        if (Object.keys(tool).length === 0) {
          this.trainObj.tools.splice(index, 1);
        }
      }
      for (let index = 0; index < this.trainObj.main.length; index++) {
        const step = this.trainObj.main[index];
        if (!step.hasOwnProperty('content') && !step.hasOwnProperty('file')) {
          this.trainObj.main.splice(index, 1);
        }
      }
    },
    //将tools中的对象格式转为字符串
    changeData() {
      //转换实训工具
      const tools = []
      for (let index = 0; index < this.trainObj.tools.length; index++) {
        const tool = this.trainObj.tools[index];
        const arr = ''
        for (let i in tool) {
          if (i == 'url') {
            arr += tool[i]
          } else {
            arr += tool[i] + '!!'
          }
        }
        tools.push(arr)
      }
      this.toolFiles = tools
      //转换实训步骤
      const steps = []
      for (let index = 0; index < this.trainObj.main.length; index++) {
        const step = this.trainObj.main[index];
        const arr = ''

        if (step['content']) {
          arr += step['content'] + '%%'
        } else {
          arr += '%%'
        }
        if (step['file']) {
          for (let i = 0; i < step['file'].length; i++) {
            if (i >= step['file'].length - 1) {
              arr += step['file'][i]['name'] + '!!' + step['file'][i]['url']
            } else {
              arr += step['file'][i]['name'] + '!!' + step['file'][i]['url'] + '@@'
            }
          }
        }
        steps.push(arr)
      }

      this.stepFiles = steps
    },
    // 实训步骤&参考资料的上传前钩子
    beforeFileUpload(type, file) {
      const imgs = ['png', 'jpg', 'jpeg', 'gif'];
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const result = this.common.beforeUploadImg(type, file);
      if (!result.success) {
        this.$message.error(result.msg)
        return false
      } else {
        if (imgs.indexOf(suffix) == -1) {
          return file;
        }
        let _this = this
        const isSize = new Promise(function (resolve, reject) {
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            let valid = img.width <= 4096 && img.height <= 4096;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          _this.$message.error('上传文件的图片宽度或者高度不能超过4096像素')
          return Promise.reject();
        });
        return isSize
      }

    },
    // 实训步骤限制传5张图
    handleExceed(type, files, fileList) {
      this.$message.warning('最多允许上传10张图片');
    },
    // 实训题教学文件上传预览\钩子
    beforeVideoUpload(file) {
      const isMP4_PDF = file.type === 'video/mp4' || file.type === 'application/pdf';
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGIF = file.type === 'image/gif';
      const isLt500M = file.size / 1024 / 1024 < 950;
      if (!isLt500M) {
        this.$message.error('上传的文件大小不能超过 950M!');
        return false
      }
      if (isJPG || isPNG || isGIF) {
        this.$message.error('不支持图片格式');
        return false
      }
      return isLt500M
    },
    tips() {
      this.$message.warning(`教学文件限制上传1个文件`);
    },
    cktips() {
      this.$message.warning(`参考资料限制上传5个文件`);
    },
    // 参考资料&教学文件的before-remove
    beforeTeachFileRemove(type, file, fileList) {
      const isLt950M = file.size / 1024 / 1024 < 950;
      if (type === 'teach') {
        const isMP4_PDF = file.type === 'video/mp4' || file.type === 'application/pdf';
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isGIF = file.type === 'image/gif';
        if (!isMP4_PDF || !isLt950M || (!isJPG && !isPNG && !isGIF)) return true;
      }
      if (type === 'materials') {
        if (!isLt950M) return true;
      }
    },
    handleFileRemove(type, file, fileList, index = 0) {
      if (type === 'teach') {
        this.trainObj.video_url.forEach((f, i) => {
          if (file.url) {
            if (f.url === file.url) {
              this.trainObj.video_url.splice(i, 1);
              return;
            }
          } else {
            if (f.url === file.response.res.requestUrls[0].split('?')[0]) {
              this.trainObj.video_url.splice(i, 1);
              return;
            }
          }
        })
      }

      if (type === 'materials') {
        this.trainObj.materials.forEach((f, i) => {
          if (file.url) {
            if (f.url === file.url) {
              this.trainObj.materials.splice(i, 1);
              return;
            }
          } else {
            if (f.url === file.response.res.requestUrls[0].split('?')[0]) {
              this.trainObj.materials.splice(i, 1);
              return;
            }
          }
        })
      }
      if (type === 'step') {
        this.trainObj.main[index].file.forEach((f, i) => {
          if (file.url) {
            if (f.url === file.url) {
              this.trainObj.main[index].file.splice(i, 1);
              return;
            }
          } else {
            if (f.url === file.response.res.requestUrls[0].split('?')[0]) {
              this.trainObj.main[index].file.splice(i, 1);
              return;
            }
          }
        })
      }
    },
    // 教学文件上传成功的回调 
    handleVideoSuccess(res, file) {
      if (!res) return
      if (res.res.status === 200) {
        this.trainObj.video_url.push({
          name: file.name,
          url: res.res.requestUrls[0].split('?')[0],
        })
      } else {
        this.$message.error('上传失败')
      }
    },
    // 资料文件上传成功的回调
    handleMaterialsSuccess(res, file) {
      if (!res) return
      if (res.res.status === 200) {
        this.trainObj.materials.push({
          name: file.name,
          url: res.res.requestUrls[0].split('?')[0]
        })
      } else {
        this.$message.error('上传失败')
      }
    },
    // 实训步骤里的图片上传成功的回调
    handleMainImgSuccess(index, res, file) {
      if (!res) return
      if (res.res.status === 200) {
        const fileObj = {
          url: res.res.requestUrls[0].split('?')[0],
          filetype: file.raw.type,
          name: file.name
        }
        if (this.trainObj.main[index].hasOwnProperty('file')) {
          this.trainObj.main[index].file.push(fileObj)
        } else {
          this.trainObj.main[index].file = [];
          this.trainObj.main[index].file.push(fileObj)
        }
        this.mainFiles[index] = this.trainObj.main[index].file
      } else {
        this.$message.error('上传失败')
      }

    },
    // 删除文件前置动作(实训步骤&教学文件)
    beforeFileRemove(type, file, fileList) {
      if (type === 'step') {
        return true;
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isGIF = file.type === 'image/gif';
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG || !isPNG || !isGIF || isLt10M) return true;
      }
      return this.$confirm(`确定移除 ${file.name}？`, '提示');
    },

    // 添加工具
    addTool() {
      if (this.trainObj.tools.length >= 3) {
        this.$message.error('实训工具最多添加3个!')
        return true
      }
      this.trainObj.tools.push({})
    },
    // 删除工具
    deleteTool(index) {
      this.trainObj.tools.splice(index, 1)
    },
    //添加实训步骤
    addStep(index = '') {
      if (index >= 0) {
        if (this.trainObj.main.length >= 100) {
          this.$message.error('实训步骤最多添加100个!')
          return true
        }
        this.trainObj.main.splice(index + 1, 0, {})
        this.mainFiles.splice(index + 1, 0, [])
      } else {
        this.trainObj.main.push({})
      }
    },
    rmStep(index = '') {
      this.trainObj.main.splice(index, 1)
      this.mainFiles.splice(index, 1)
    },
    //上移实训步骤
    upSteps: function (index) {
      if (index === 0) {
        return true
      }
      let main = this.trainObj.main
      main[index] = main.splice(index - 1, 1, main[index])[0]
      if (!this.mainFiles[index - 1]) {
        this.mainFiles[index - 1] = []
      }
      this.mainFiles[index] = this.mainFiles.splice(index - 1, 1, this.mainFiles[index])[0]
    },
    //下移实训步骤
    downSteps: function (index) {
      let main = this.trainObj.main
      if (index >= main.length) {
        return true
      }
      main[index] = main.splice(index + 1, 1, main[index])[0]
      if (!this.mainFiles[index + 1]) {
        this.mainFiles[index + 1] = []
      }
      this.mainFiles[index] = this.mainFiles.splice(index + 1, 1, this.mainFiles[index])[0]
    },
    onStepMove({ relatedContext, draggedContext }) {

    },
    onStepMoveEnd(e) {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      this.mainFiles = []
      this.restoreMainFiles()
    },
    getStepContent(obj) {
      this.trainObj.main[obj.index].content = obj.content
    },
    /**
      * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
      * @param    {object}   option [上传选项]
      * @return   {null}   [没有返回]
      */
    async fnUploadRequest(option) {
      oss.ossUploadFile(option, 2)
    },

  },

}
</script>

<style scoped>
@import "../../assets/css/create-item.css";
</style>